export default "__VITE_ASSET__BHuQGjR7__"